import { z } from "zod";
import { common } from "../common";

export const audienceDescriptionHashSchema = z.object({
  apps: z.array(z.unknown()), // In sample data this is only ever an empty array.
  filters: z.array(z.array(z.string())),
  segments: z.array(z.string()),
  segments_details: z
    .array(
      z.object({
        id: common.objectId,
        name: z.string(),
        summary: z.string(),
      })
    )
    .optional(),
});
